/* ============================================================
   RYVA · Traduce SOLO la interfaz del widget de reseñas.
   ------------------------------------------------------------
   assets/ryva-reviews.js contiene 136 reseñas reales de clientes.
   Ese archivo NO se toca: el texto de las reseñas es contenido de
   clientes y traducirlo es una decisión editorial aparte.
   Este complemento se limita a la cromática del widget (botones,
   cabecera, filtros, estados) y lee de window.RYVA_I18N.
   Si el idioma activo es español no hace absolutamente nada.
   Cargado desde snippets/copy-toast.liquid, después de ryva-reviews.js.
   ============================================================ */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;

  var LOCALE = window.RYVA_LOCALE || document.documentElement.lang || 'es';
  if (/^es/i.test(LOCALE)) return; // en español el widget ya está bien

  function RY(k, fb) {
    var d = window.RYVA_I18N;
    return (d && typeof d[k] === 'string' && d[k].length) ? d[k] : fb;
  }

  /* Las etiquetas de filtro van en el mismo orden que CHIPS en ryva-reviews.js */
  var CHIP_KEYS = ['f_sleep_better', 'f_less_fatigue', 'f_good_quality', 'f_comfortable', 'f_recommend', 'f_excellent'];

  function num(el) {
    var m = (el.textContent || '').match(/(\d[\d.,]*)/);
    return m ? m[1] : '';
  }

  function translateTrigger(wrap) {
    var link = wrap.querySelector('.rvw-link');
    if (link && !link.hasAttribute('data-ry-i18n')) {
      link.textContent = RY('rv_read', 'Leer {n} reseñas').replace('{n}', num(link) || '136');
      link.setAttribute('data-ry-i18n', '1');
    }
  }

  function translateModal(modal) {
    if (modal.getAttribute('data-ry-i18n') !== '1') {
      modal.setAttribute('data-ry-i18n', '1');

      var dialog = modal.querySelector('.rvw-dialog');
      if (dialog) dialog.setAttribute('aria-label', RY('rv_aria_reviews', 'Reseñas'));

      var close = modal.querySelector('.rvw-close');
      if (close) close.setAttribute('aria-label', RY('rv_close', 'Cerrar'));

      /* Frase completa en una sola clave: cada idioma ordena las palabras a su manera. */
      var meta = modal.querySelector('.rvw-h-meta');
      if (meta) {
        var b = meta.querySelector('b');
        var n = b ? num(b) : '136';
        meta.innerHTML = RY('rv_meta', 'Basado en <b>{n} reseñas</b> verificadas').replace('{n}', n);
      }

      var hl = modal.querySelector('.rvw-hl-label');
      if (hl) hl.textContent = RY('rv_highlights', 'Lo que más destacan');
    }

    /* chips: se construyen una sola vez */
    var chips = modal.querySelectorAll('.rvw-chip');
    Array.prototype.forEach.call(chips, function (c) {
      if (c.hasAttribute('data-ry-i18n')) return;
      var small = c.querySelector('small');
      var count = small ? small.outerHTML : '';
      var label;
      if (c.hasAttribute('data-all')) {
        label = RY('rv_all', 'Todas');
      } else {
        var i = parseInt(c.getAttribute('data-i'), 10);
        label = RY(CHIP_KEYS[i] || '', c.firstChild ? String(c.firstChild.textContent).trim() : '');
      }
      c.innerHTML = label + ' ' + count;
      c.setAttribute('data-ry-i18n', '1');
    });

    /* lista: se vuelve a pintar cada vez que cambia el filtro */
    var list = modal.querySelector('[data-list]');
    if (!list) return;
    Array.prototype.forEach.call(list.querySelectorAll('.rvw-vf'), function (v) {
      if (v.hasAttribute('data-ry-i18n')) return;
      v.textContent = RY('rv_verified_buy', '✓ Compra verificada');
      v.setAttribute('data-ry-i18n', '1');
    });
    var empty = list.querySelector('.rvw-empty');
    if (empty && !empty.hasAttribute('data-ry-i18n')) {
      empty.textContent = RY('rv_empty', 'Sin reseñas para este filtro.');
      empty.setAttribute('data-ry-i18n', '1');
    }
  }

  function sweep() {
    var wrap = document.querySelector('.ryva-rvw');
    if (wrap) translateTrigger(wrap);
    var modal = document.querySelector('.rvw-modal');
    if (modal) translateModal(modal);
    return !!(wrap && modal);
  }

  function start() {
    sweep();
    /* el widget se inyecta tarde (espera a Loox) y repinta la lista al filtrar */
    try {
      var mo = new MutationObserver(function () { sweep(); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {
      var n = 0, iv = setInterval(function () { if (sweep() || ++n > 40) clearInterval(iv); }, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();